export const SET_ORDERS_DATA = 'SET_ORDERS_DATA'
export const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';
export const ADD_NEW_ORDER = 'ADD_NEW_ORDER';
export const UPDATE_DELIVERY_DETAILS = 'UPDATE_DELIVERY_DETAILS';
export const SET_PARTNER = 'SET_PARTNER';
export const SET_SUBMITTING_STATUS = 'SET_SUBMITTING_STATUS';
export const SET_ADJUST_ORDER_MODAL = 'SET_ADJUST_ORDER_MODAL';
export const AWAITING_REFUND = 'AWAITING_REFUND';

export const AWAITING_SHOP_CONFIRMATION = 'AWAITING_SHOP_CONFIRMATION';
export const ACCEPTED = 'ACCEPTED';
export const READY = 'READY';

export const DELIVERY = 'DELIVERY';
export const COLLECT = 'COLLECT';

export const APPROVED = 'APPROVED';
export const DECLINED = 'DECLINED';
export const THREEDREQUIRED = 'THREEDREQUIRED';
export const PAY_LATER = 'PAY_LATER';